import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";

import Header from './Desktop/header';
import getApiData from "../../hooks/apiRequests/getRequest";

function BackOffice() {
    const [headerData, setHeaderData] = useState();
    const navigate = useNavigate();
    
    useEffect(() => {
        const fetchData = async () => {
            try {
              const response = await getApiData(`/HeaderData`);
              setHeaderData(response.data);
              if (response?.data?.user?.roles !== 'Versite_Admin'){
                navigate(`/Portal/Dashboard`);
              }
            } catch (error) {
              console.error('Error fetching post data:', error);
              navigate(`/Company`);
            }
        };
        fetchData();
    }, [navigate]);

    return(
        <>
            <Header headerData={headerData}/>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Outlet />
            </Box>
        </>
    );

};

export default BackOffice;